import styles from "./SchoolHero.module.css";
import {
  FaRocket,
  FaArrowRight,
  FaCogs,
  FaChartLine,
  FaGraduationCap,
  FaSchool,
  FaUser,
  FaGlobe,
  FaLaptopCode,
  FaCity,
  FaChalkboardTeacher,
} from "react-icons/fa";

const SchoolHero = () => {
  const quickStats = [
    { icon: <FaUser />, value: "1.2 Lakh+", label: "Happy Children" },
    { icon: <FaChalkboardTeacher />, value: "120+", label: "Mentors" },
    { icon: <FaSchool />, value: "240+", label: "Schools" },
    { icon: <FaCity />, value: "7+ Cities", label: "across India" },
  ];

  const handleDemoClick = () => {
    const formElement = document.getElementById("cta-form");
    formElement?.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <section className={styles.hero}>
      <div className={styles.content}>
        <div className={styles.leftContent} data-aos="fade-up">
          <h1>
            Kick-start your School with{" "}
            <span className={styles.highlight}>
              Robotics & AI program through STEM Learning!
            </span>
          </h1>
          <p>
            We are committed to effectively implementing the STEM program at
            your institution with minimal initial investment, and a qualified
            STEM engineer from STEMx will be assigned as a full-time faculty
            member at the school.
          </p>
          <div
            className={styles.buttons}
            data-aos="fade-up"
            data-aos-delay="300"
          >
            <button className={styles.primary}>
              <a
                href="https://youtu.be/Lki1oJOklXY?feature=shared"
                target="_blank"
                rel="noopener noreferrer"
                style={{ textDecoration: "none", color: "white" }}
              >
                Watch Video <FaRocket className={styles.icon} />
              </a>
            </button>
            <button className={styles.secondary} onClick={handleDemoClick}>
              <div className={styles.button_content}>
                {" "}
                Request Demo <FaArrowRight className={styles.icon} />
              </div>
            </button>
            <span className={styles.buttoninfo}>
              *For Schools & Channel Partners only
            </span>
          </div>
        </div>
      </div>
      <div className={styles.statsGrid}>
        {quickStats.map((stat, index) => (
          <div key={index} className={styles.quickStat}>
            <div className={styles.statIcon}>{stat.icon}</div>
            <div className={styles.statValue}>{stat.value}</div>
            <div className={styles.statLabel}>{stat.label}</div>
          </div>
        ))}
      </div>
    </section>
  );
};

export default SchoolHero;
